import {markRaw} from 'vue'
import {Component, Vue} from 'vue-facing-decorator'

interface Destroyable {
    destroy(): void
}

/**
 * Ciclo de vida de uma instância do Toast UI dentro de um componente.
 *
 * Quem estende desenha um `<div ref="host"/>` e implementa `create(el)`; esta classe
 * monta no `mounted` e destrói no `beforeUnmount`. É o mesmo idioma das outras
 * classes-base do projeto — por ser base, e não componente, não leva toNative.
 *
 * A instância passa por `markRaw` de propósito. Campo de classe vira dado reativo, e o
 * Vue 3 envolveria o objeto do Toast UI — e o ProseMirror dentro dele — num Proxy. O
 * Proxy intercepta o estado interno do editor, e o resultado é defeito difícil de ler.
 * Em Vue 2 isso não acontecia, porque o observer não alcançava o objeto do mesmo jeito.
 */
@Component
export default class ToastHost<T extends Destroyable> extends Vue {
    instance: T | null = null

    create(el: HTMLElement): T {
        throw new Error(`${this.$options.name}: create(el) não implementado (${el.tagName})`)
    }

    mounted() {
        this.instance = markRaw(this.create(this.$refs.host as HTMLElement)) as T
    }

    beforeUnmount() {
        this.instance?.destroy()
        this.instance = null
    }
}
